import React from "react"
import { Box, Divider, Grid } from "@mui/material"
import { BillingInformationPanel } from "./BillingInformationPanel"
import { CompanyDomainsPanel } from "./CompanyDomainsPanel"
import { InvoicingContactPanel } from "./InvoicingContactPanel"

export const CompanyInfoTab = () => (
  <Box sx={{ p: { xs: 2, md: 8 }, flex: 1, minHeight: 0, overflow: "auto", display: "flex", flexDirection: "column" }}>
    <Grid container spacing={8} sx={{ flexGrow: 1 }}>
      <Grid item xs={12} md={7}>
        <BillingInformationPanel />
        <Divider sx={{ borderBottomWidth: 2, my: 3 }} />
        <CompanyDomainsPanel />
      </Grid>
      <Grid item xs={12} md={5} sx={{ display: "flex", flexDirection: "column" }}>
        <InvoicingContactPanel />
      </Grid>
    </Grid>
  </Box>
)
